import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';

const ProgressSteps = ({ currentStep, totalSteps, labels = [], completedSteps = [] }) => {
  // Verificar se um step está completo
  // completedSteps pode ser um array de índices (1-based) dos steps completados
  const isStepCompleted = (stepIndex) => {
    // Se completedSteps foi passado, usar ele
    if (completedSteps && completedSteps.length > 0) {
      return completedSteps.includes(stepIndex + 1);
    }
    // Fallback: considerar completo se for anterior ao step atual
    return stepIndex + 1 < currentStep;
  };

  // Calcular progresso baseado em steps completados ou step atual
  const calculateProgress = () => {
    if (completedSteps && completedSteps.length > 0) {
      // Progresso baseado em quantos steps estão completos
      return (completedSteps.length / totalSteps) * 100;
    }
    // Fallback: progresso baseado no step atual
    return ((currentStep - 1) / totalSteps) * 100;
  };

  return (
    <div className="w-full max-w-2xl mx-auto">
      {/* Progress bar */}
      <div className="relative h-2 bg-[#FAE0D5] rounded-full overflow-hidden mb-4">
        <motion.div 
          className="absolute h-full rounded-full"
          style={{ background: 'linear-gradient(90deg, #8F7AC5 0%, #D98DAE 100%)' }}
          initial={{ width: 0 }}
          animate={{ width: `${calculateProgress()}%` }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
        />
      </div>
      
      {/* Step indicators */}
      <div className="flex justify-between">
        {Array.from({ length: totalSteps }, (_, i) => {
          const completed = isStepCompleted(i);
          const isCurrent = i + 1 === currentStep;
          
          return (
            <div key={i} className="flex flex-col items-center">
              <motion.div 
                className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-colors
                  ${completed
                    ? 'bg-[#7BC47F] text-white'  // Verde para completo
                    : isCurrent 
                      ? 'bg-[#D98DAE] text-white'  // Rosa para atual
                      : 'bg-[#FAE0D5] text-[#9890A8]'  // Cinza para pendente
                  }`}
                initial={{ scale: 0.8 }}
                animate={{ scale: isCurrent ? 1.1 : 1 }}
                transition={{ duration: 0.3 }}
              >
                {completed ? <Check className="w-4 h-4" /> : i + 1}
              </motion.div>
              {labels[i] && (
                <span className={`text-xs mt-1 ${
                  completed ? 'text-[#7BC47F] font-medium' : 
                  isCurrent ? 'text-[#30244F] font-medium' : 
                  'text-[#9890A8]'
                }`}>
                  {labels[i]}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressSteps;
